import React, { SyntheticEvent } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useSlate } from 'slate-react';

import { changeSelectedField } from 'store/actions/editorSlate';
import { RootStateType } from 'store/reducers';
import { IBlockButtonProps } from 'types/Editor';
import { isBlockActive } from 'utils/editorBlockHelpers';
import { removeSlateSelectedFieldError } from 'utils/editorFieldHelpers';
import { toggleTextField } from 'utils/editorTextFieldHelpers';

const QuestionFieldButton: React.FC<IBlockButtonProps> = ({ format, icon }) => {
  const editor = useSlate();
  const selectedAssignment = useSelector((state: RootStateType) => state.editorSlate.selectedAssignment);
  const active: boolean = isBlockActive(editor, format);
  const dispatch = useDispatch();

  const onMouseDownButton = (event: SyntheticEvent) => {
    event.preventDefault();
    removeSlateSelectedFieldError(editor, format, active, dispatch);
    const questionFieldkey = toggleTextField(editor, format, selectedAssignment);

    dispatch(changeSelectedField(questionFieldkey));
  };

  return (
    <span
      className={`btn-toolbar-editor horizontal-toolbar-icon ${active && 'text-dark'}`}
      onMouseDown={onMouseDownButton}
      role="button"
      tabIndex={-1}
    >
      {icon}
    </span>
  );
};

export default QuestionFieldButton;